import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "icon"]

  toggle () {
    const hidden = this.inputTarget.type === "password"
    this.inputTarget.type = hidden ? "text" : "password"
    if (this.hasIconTarget) {
      this.iconTarget.className = hidden ? "ph ph-eye-slash" : "ph ph-eye"
    }
  }
}
